unit PrepareOperationItemListType;

interface

uses
  PrepareOperationItemType;

type
  TPrepareOperationItemListType = array of TPrepareOperationItemType;

implementation

end.
